import InfoCircleFilled from '../../src/legacy/InfoCircleFilled';
export default InfoCircleFilled;
